import { useContext } from 'react';
import warning from '../../_util/warning';
import { FormItemInputContext } from '../context';
const useFormItemStatus = () => {
    const { status } = useContext(FormItemInputContext);
    warning(status !== undefined, 'Form.Item', `Form.Item.useStatus should be used under Form.Item component. For more information: ${window.location.protocol}//${window.location.host}/components/form-cn/#Form.Item.useStatus`);
    return { status };
};
export default useFormItemStatus;
